
import { limitedStockThreshold } from '@/utils/constants'

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLimited: {
      type: Boolean,
      default: null,
    },
    stock: {
      type: Number,
      default: null,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      limitedStockThreshold,
    }
  },
}
